var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7813 50.8H28.2187C27.5455 50.8 27 50.2629 27 49.6V34.8919C27 34.2294 27.5455 33.6919 28.2187 33.6919H33.4238L35.3757 30.4785C35.5983 30.1895 35.947 30 36.3438 30H43.6562C43.9986 30 44.3065 30.1402 44.5283 30.3637L44.5291 30.3625L46.5988 33.6919H51.7813C52.4545 33.6919 53 34.2294 53 34.8919V49.6C53 50.2629 52.4545 50.8 51.7813 50.8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.3 4C0.3 1.95655 1.95655 0.3 4 0.3H76C78.0434 0.3 79.7 1.95655 79.7 4V76C79.7 78.0434 78.0434 79.7 76 79.7H4C1.95655 79.7 0.3 78.0434 0.3 76V4Z",
    fill: "#ECECEE",
    stroke: "#D5D5D5",
    strokeWidth: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7813 50.8H28.2187C27.5455 50.8 27 50.2629 27 49.6V34.8919C27 34.2294 27.5455 33.6919 28.2187 33.6919H33.4238L35.3757 30.4785C35.5983 30.1895 35.947 30 36.3438 30H43.6562C43.9986 30 44.3065 30.1402 44.5283 30.3637L44.5291 30.3625L46.5988 33.6919H51.7813C52.4545 33.6919 53 34.2294 53 34.8919V49.6C53 50.2629 52.4545 50.8 51.7813 50.8ZM40.0003 36.1523C36.4447 36.1523 33.5625 38.9905 33.5625 42.491C33.5625 45.9919 36.4447 48.8298 40.0003 48.8298C43.5558 48.8298 46.438 45.9919 46.438 42.491C46.438 38.9905 43.5558 36.1523 40.0003 36.1523ZM36.2734 42.4926C36.2734 44.5184 37.9416 46.161 39.9991 46.161C42.0569 46.161 43.7248 44.5184 43.7248 42.4926C43.7248 40.4664 42.0569 38.8242 39.9991 38.8242C37.9416 38.8242 36.2734 40.4664 36.2734 42.4926Z",
    fill: "#414141"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_13797",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 36,
    width: 14,
    height: 13
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5625 42.491C33.5625 38.9905 36.4447 36.1523 40.0003 36.1523C43.5558 36.1523 46.438 38.9905 46.438 42.491C46.438 45.9919 43.5558 48.8298 40.0003 48.8298C36.4447 48.8298 33.5625 45.9919 33.5625 42.491ZM36.2734 42.4926C36.2734 44.5184 37.9416 46.161 39.9991 46.161C42.0569 46.161 43.7248 44.5184 43.7248 42.4926C43.7248 40.4664 42.0569 38.8242 39.9991 38.8242C37.9416 38.8242 36.2734 40.4664 36.2734 42.4926Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_13797)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminPhoto);
export default __webpack_public_path__ + "static/media/ic_admin_photo.29ef1a0b1cfa742a10a10de705106249.svg";
export { ForwardRef as ReactComponent };